var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIron(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.408 2.5C18.9621 2.49573 21.1471 4.33386 21.58 6.85095L23.932 20.326C23.9834 20.6171 23.9035 20.9159 23.7137 21.1423C23.5238 21.3689 23.2435 21.4998 22.948 21.5H0.548004C0.271851 21.5 0.0480042 21.2761 0.0480042 21C0.0546265 15.2037 4.75177 10.5066 10.548 10.5H19.083C19.2307 10.5001 19.371 10.4349 19.4661 10.3219C19.5612 10.2089 19.6014 10.0596 19.576 9.91406L19.117 7.27795C18.8895 5.96021 17.7454 4.99805 16.408 5H8.522C7.83163 5 7.272 4.44031 7.272 3.75C7.272 3.05969 7.83163 2.5 8.522 2.5H16.408ZM6.452 16C6.452 16.8284 7.12357 17.5 7.952 17.5C8.78043 17.5 9.452 16.8284 9.452 16C9.452 15.1716 8.78043 14.5 7.952 14.5C7.12357 14.5 6.452 15.1716 6.452 16ZM12.952 17.5C12.1236 17.5 11.452 16.8284 11.452 16C11.452 15.1716 12.1236 14.5 12.952 14.5C13.7804 14.5 14.452 15.1716 14.452 16C14.452 16.8284 13.7804 17.5 12.952 17.5ZM16.452 16C16.452 16.8284 17.1236 17.5 17.952 17.5C18.7804 17.5 19.452 16.8284 19.452 16C19.452 15.1716 18.7804 14.5 17.952 14.5C17.1236 14.5 16.452 15.1716 16.452 16Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIron);
export default __webpack_public_path__ + "static/media/iron.8a6f9702.svg";
export { ForwardRef as ReactComponent };